const ENTER = 13;
const ESC = 27;
const BACKSPACE = 8;
const SPACE = 32;
const ARROW_LEFT = 37;
const ARROW_UP = 38;
const ARROW_RIGHT = 39;
const ARROW_DOWN = 40;

export default {
  ENTER,
  ESC,
  BACKSPACE,
  SPACE,
  ARROW_LEFT,
  ARROW_UP,
  ARROW_RIGHT,
  ARROW_DOWN,
};
